type Brand<T, B extends string> = T & { readonly __idBrand: B };

export type EntityId = Brand<string, 'EntityId'>;
export type DatabaseEntityId = Brand<string, 'DatabaseEntityId'>;

export type EntityRef = {
  entityId: EntityId;
  databaseEntityId: DatabaseEntityId;
};

type EntityRowLike = {
  id?: string | number | null;
  entity_id?: string | number | null;
  association_id?: string | number | null;
  database_entity_id?: string | number | null;
};

const clean = (value: unknown): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : null;
};

const firstId = (...candidates: unknown[]): string | null => {
  for (const candidate of candidates) {
    const value = clean(candidate);
    if (value) {
      return value;
    }
  }
  return null;
};

export const asEntityId = (value: string): EntityId => value as EntityId;
export const asDatabaseEntityId = (value: string): DatabaseEntityId =>
  value as DatabaseEntityId;

export const entityRef = (row?: EntityRowLike | null): EntityRef | null => {
  if (!row) {
    return null;
  }

  const databaseEntityId = firstId(row.association_id, row.database_entity_id);
  const entityId = firstId(row.entity_id, row.id);

  if (!databaseEntityId || !entityId) {
    return null;
  }

  return {
    entityId: asEntityId(entityId),
    databaseEntityId: asDatabaseEntityId(databaseEntityId),
  };
};
